import { inject as e } from "vue";
import { isDynamicRef as t, resolveDynamicRef as n } from "@scalar/workspace-store/helpers/dynamic-ref";
//#region src/schema/helpers/dynamic-scope.ts
var r = Symbol("schema-dynamic-scope"), i = [], a = () => e(r, i), o = (e, r) => t(e) ? n(e.$dynamicRef, r) ?? e : e;
//#endregion
export { r as SCHEMA_DYNAMIC_SCOPE_SYMBOL, o as resolveDynamicSchema, a as useDynamicScope };

//# sourceMappingURL=dynamic-scope.js.map